import React, { useEffect, useState } from "react";
import { Stack, Switch, Checkbox, TextField, Chip } from "@mui/material";
import { InputControl } from "../../../shared";
import { Close } from "@mui/icons-material";

export default function RecipeTaggingSection({
  tipsAndTricks,
  onChange,
  onDeleteRecipeSelect,
  RecipeOptions,
  validator,
}) {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    validator?.current?.purgeFields?.();
  }, [tipsAndTricks, validator]);

  return (
    <Stack gap="16px">
      <Switch
        name="type"
        checked={tipsAndTricks.type === 1}
        onChange={(e) => onChange(e, "type")}
        edge="start"
      />
      {tipsAndTricks?.type === 1 && (
        <React.Fragment>
          <InputControl
            type="dropdown"
            name="recipe_id"
            multiple={true}
            options={RecipeOptions ?? []}
            value={RecipeOptions?.filter((op) =>
              tipsAndTricks?.data?.recipe_id?.find(
                (item) => item?.id === op?.id
              )
            )}
            inputValue={inputValue}
            disableCloseOnSelect
            disableClearable={true}
            onChange={(e, v) =>
              onChange({
                target: {
                  name: "recipe_id",
                  value: v,
                },
              })
            }
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => <></>)
            }
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.id}>
                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                {option.name}
              </li>
            )}
            filterOptions={(options, { inputValue }) =>
              options.filter((option) =>
                option.name.toLowerCase().includes(inputValue.toLowerCase())
              )
            }
            onInputChange={(event, newInputValue, reason) => {
              if (reason !== "reset") {
                // keep input after selecting
                setInputValue(newInputValue);
              }
            }}
            onBlur={() => setInputValue("")}
            sx={{ width: 255 }}
            componentsProps={{
              paper: {
                sx: {
                  width: "100%",
                  minWidth: 250,
                },
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Type or Select Recipes"
                placeholder="Type or Select Recipes"
              />
            )}
          />
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            {tipsAndTricks?.data?.recipe_id?.length > 0 &&
              tipsAndTricks?.data?.recipe_id?.map((data, index) => (
                <Chip
                  key={index}
                  variant="outlined"
                  color="gray"
                  label={data?.name}
                  deleteIcon={<Close />}
                  onDelete={() => {
                    onDeleteRecipeSelect(data);
                  }}
                  sx={{
                    "& .MuiChip-deleteIcon": {
                      fontSize: "18px",
                    },
                  }}
                />
              ))}
          </Stack>
        </React.Fragment>
      )}
    </Stack>
  );
}
